import { useContext } from 'react'
import DashboardLayout from "defaultComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "defaultComponents/Navbars/DashboardNavbar";
import { Grid } from '@mui/material';
import * as S from "./style";
import underConstruction from 'assets/ze_sitting.png';
import ButtonCustom from 'components/ButtonCustom/ButtonCustom';
import VuiProgress from "components/VuiProgress";
import { useNavigate } from 'react-router-dom';
import { TokenContext } from 'context/TokenContext';

const FirstCommunity = () => {
  const navigate = useNavigate();
  const { decodedToken } = useContext(TokenContext);

  const handleCreateCommunity = () => {
    navigate('/comunidade/criar');
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <S.MainGrid container item sm={12} md={12} lg={12} xl={12}>
        <Grid container>
          <S.ZeGrid container item xs={7} sm={6} md={6} xl={5} justifyContent='flex-end'>
            <img src={underConstruction} draggable='false' />
          </S.ZeGrid>
          <S.BaloonGrid item xs={12} sm={12} md={6} xl={3.5} justifyContent='flex-start' flexDirection='column'>
            <VuiProgress value={10} color="transfer" label={false} sx={{ background: "#D9D9D9" }} />
            <Grid display='flex' gap='10px' flexDirection='row' pt='15px'>
              <h3>Olá,</h3>
              <Grid container>
                <h3 className='greetingName'>{decodedToken?.name}</h3>
                <h3>!</h3>
              </Grid>
            </Grid>
            <S.ExplanationGrid container flexDirection='column'>
              <p>Eu sou o <b>Zê</b>, aqui serei seu agente de comunidade.</p>
              <p><b>Você quer criar sua primeira comunidade?</b></p>
              <p>Vou estar te auxiliando nessa jornada!</p>
            </S.ExplanationGrid>
            <Grid container justifyContent='center'>
              <ButtonCustom
                onClick={handleCreateCommunity}
                label='Criar minha primeira comunidade'
                sx={{ fontSize: "16px", fontWeight: "500", marginTop: '20px' }}
              />
            </Grid>
          </S.BaloonGrid>
        </Grid>
      </S.MainGrid>
    </DashboardLayout>
  )
}

export default FirstCommunity